// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

class AnnouncementBar extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host([loaded]) {
        max-height: var(--Announcement_Height);
      }
      @media (prefers-reduced-motion: no-preference) {
        :host([loaded]) {
          transition: max-height 0.3s ease, background-color 0.3s ease;
        }
      }
    `
  }

  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.els.body.element.offsetHeight}px`,
    )

    this.setAttribute('loaded', '')

    let counter = 0

    this.els.slide.elements.forEach(slide => {
      const slideRegion = slide.dataset.region.toUpperCase()

      // The options available in the customiser are 'GB', 'ROW' and 'ALL'.
      const userLocation =
        window.localStorage.getItem(this.userLocationName) === 'GB'
          ? 'GB'
          : 'ROW'

      // Slides are active when they don't have a region. (Region set to 'All' in the customiser)
      // Slides with a region are only active when the region matches the user's location.
      const isActiveSlide = slideRegion?.length
        ? slideRegion === userLocation
        : true

      slide.classList.toggle('hd-AnnouncementBar_Item-hidden', !isActiveSlide)

      if (isActiveSlide) {
        slide.setAttribute('aria-hidden', counter !== 0)

        counter = counter + 1
      }
    })

    if (counter < 2) return

    this.interval = 0

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(this.els.slides.element, {
      selector: '.hd-AnnouncementBar_Item:not(.hd-AnnouncementBar_Item-hidden)',
      loop: true,
      renderMode: 'custom',
      slideChanged: this.onSlideChanged,
      created: () => {
        this.autoplay(true)
      },
      dragStarted: () => {
        this.autoplay(false)
      },
      dragEnded: () => {
        this.autoplay(true)
      },
    })
  }

  autoplay (run) {
    clearInterval(this.interval)

    this.interval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, 3000)
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel
    let activeSlideCount = 0

    this.els.slide.elements.forEach(slide => {
      if (!slide.classList.contains('hd-AnnouncementBar_Item-hidden')) {
        slide.setAttribute('aria-hidden', activeSlideCount !== currentSlide)

        activeSlideCount = activeSlideCount + 1
      }
    })
  }

  get userLocationName () {
    return `BAO-location-sunspel`
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
